var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 27,
    viewBox: "0 0 84 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-652 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 27,
    rx: 13.5,
    transform: "translate(652 579)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.263,1304.709a6.582,6.582,0,0,0-6.385,5.114h-2.943a6.524,6.524,0,0,0-12.739,0h-2.943a6.533,6.533,0,0,0-12.754,0h-2.943a6.525,6.525,0,1,0,.016,2.8h2.911a6.54,6.54,0,0,0,12.786,0h2.912a6.53,6.53,0,0,0,12.77,0h2.911a6.539,6.539,0,1,0,6.4-7.913Zm-43.505,7.913a3.844,3.844,0,1,1,0-2.8,3.723,3.723,0,0,1,0,2.8Zm15.6,0a3.777,3.777,0,0,1-3.49,2.363,3.739,3.739,0,0,1-3.474-2.363,3.828,3.828,0,0,1-.257-1.368,3.5,3.5,0,0,1,.289-1.431,3.728,3.728,0,0,1,6.9,0,3.5,3.5,0,0,1,.29,1.431A3.828,3.828,0,0,1,574.358,1312.622Zm15.681,0a3.734,3.734,0,0,1-6.947,0,3.829,3.829,0,0,1-.258-1.368,3.5,3.5,0,0,1,.29-1.431,3.715,3.715,0,0,1,6.883,0,3.5,3.5,0,0,1,.29,1.431A3.828,3.828,0,0,1,590.039,1312.622Zm12.224,2.363a3.739,3.739,0,0,1-3.474-2.363,3.828,3.828,0,0,1-.258-1.368,3.5,3.5,0,0,1,.29-1.431,3.73,3.73,0,1,1,3.442,5.162Z",
    transform: "translate(115.343 -718.709)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttLinear);
export default __webpack_public_path__ + "static/media/att-linear.5fd51d1e3903ef33c0d6abcf2b0a4b0f.svg";
export { ForwardRef as ReactComponent };